export const formsTranslations = {
  // Services Page
  'services.title': {
    ru: 'Наши услуги',
    kz: 'Біздің қызметтеріміз',
    en: 'Our Services'
  },
  'services.subtitle': {
    ru: 'Мы предлагаем широкий спектр медицинской помощи спортсменам и всем, кто заботится о своем здоровье.',
    kz: 'Біз спортшыларға және өз денсаулығына қамқорлық жасайтындарға арналған кең ауқымды медициналық қызметтер ұсынамыз.',
    en: 'We offer a wide range of medical care for athletes and all those who care about their health.'
  },
  'services.list.checkup': {
    ru: 'Медицинский чекап спортсменов',
    kz: 'Спортшыларға арналған медициналық чекап',
    en: 'Medical checkup for athletes'
  },
  'services.list.rehab': {
    ru: 'Реабилитация после травм и операций',
    kz: 'Жарақаттан және операциядан кейін оңалту',
    en: 'Rehabilitation after injuries and operations'
  },
  'services.list.consult': {
    ru: 'Консультации спортивных врачей',
    kz: 'Спорттық дәрігерлерден кеңес',
    en: 'Sports doctors consultations'
  },
  'services.list.diagnostic': {
    ru: 'Диагностика и лабораторные анализы',
    kz: 'Диагностика және зертханалық талдаулар',
    en: 'Diagnostics and laboratory tests'
  },
  'services.list.physio': {
    ru: 'Физиотерапия и восстановление',
    kz: 'Физиотерапия және қалпына келтіру',
    en: 'Physiotherapy and recovery'
  },
  'services.list.nutrition': {
    ru: 'Питание и индивидуальные планы',
    kz: 'Тамақтану және жеке бағдарламалар',
    en: 'Nutrition and individual plans'
  },

  // Team Page
  'team.title': {
    ru: 'Наша команда специалистов',
    kz: 'Біздің мамандар командасы',
    en: 'Our Team of Specialists'
  },
  'team.more': {
    ru: 'Подробнее',
    kz: 'Толығырақ',
    en: 'More Details'
  },
  'team.experience': {
    ru: 'Стаж',
    kz: 'Тәжірибе',
    en: 'Experience'
  },
  'team.education': {
    ru: 'Образование',
    kz: 'Білімі',
    en: 'Education'
  },
  'team.specialization': {
    ru: 'Специализация',
    kz: 'Мамандануы',
    en: 'Specialization'
  },
  'team.certificates': {
    ru: 'Квалификация',
    kz: 'Біліктілік',
    en: 'Certificates'
  },
  'team.back': {
    ru: 'Назад к списку',
    kz: 'Тізімге оралу',
    en: 'Back to List'
  },

  // Registration Form
  'register.title': {
    ru: 'Регистрация',
    kz: 'Тіркелу',
    en: 'Registration'
  },
  'register.name': {
    ru: 'Полное имя',
    kz: 'Толық аты',
    en: 'Full Name'
  },
  'register.email': {
    ru: 'Электронная почта',
    kz: 'Электрондық пошта',
    en: 'Email'
  },
  'register.phone': {
    ru: 'Номер телефона',
    kz: 'Телефон нөмірі',
    en: 'Phone Number'
  },
  'register.password': {
    ru: 'Пароль',
    kz: 'Құпия сөз',
    en: 'Password'
  },
  'register.confirm': {
    ru: 'Подтвердите пароль',
    kz: 'Құпия сөзді растаңыз',
    en: 'Confirm Password'
  },
  'register.button': {
    ru: 'Зарегистрироваться',
    kz: 'Тіркелу',
    en: 'Register'
  },
  'register.login': {
    ru: 'Уже есть аккаунт? Войти',
    kz: 'Тіркелгіңіз бар ма? Кіру',
    en: 'Already have an account? Login'
  },
  'register.captcha': {
    ru: 'Пожалуйста, подтвердите, что вы не робот',
    kz: 'Робот емес екеніңізді растаңыз',
    en: 'Please confirm that you are not a robot'
  },

  // Login Form
  'login.title': {
    ru: 'Вход в систему',
    kz: 'Жүйеге кіру',
    en: 'Login'
  },
  'login.email': {
    ru: 'Электронная почта',
    kz: 'Электрондық пошта',
    en: 'Email'
  },
  'login.password': {
    ru: 'Пароль',
    kz: 'Құпия сөз',
    en: 'Password'
  },
  'login.button': {
    ru: 'Войти',
    kz: 'Кіру',
    en: 'Login'
  },
  'login.register': {
    ru: 'Нет аккаунта? Регистрация',
    kz: 'Тіркелгіңіз жоқ па? Тіркелу',
    en: 'No account? Register'
  },
  'login.forgot': {
    ru: 'Забыли пароль?',
    kz: 'Құпия сөзді ұмыттыңыз ба?',
    en: 'Forgot Password?'
  }
};
